// [ai] The host inside an in-process widget (a catalog component or a trusted module): the frame provides it (widgets/Frame.tsx).
import { createContext, useContext } from "react";
import type { AtlasHost } from "./types";
export const AtlasContext = createContext<AtlasHost | null>(null);
export function useAtlas(): AtlasHost { const h = useContext(AtlasContext); if (!h) throw new Error("useAtlas() works inside a widget only"); return h; }
